import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import en from './locales/en.json'
import ro from './locales/ro.json'

import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'createOrder',
  menu: [
    {
      title: <FormattedMessage id="createOrder.menu.title" />,
      key: 'createOrder',
      url: '/createOrder',
      icon: 'icmn icmn-history',
      // roles: ['business'],
    },
  ],
  routes: [
    {
      path: '/createOrder',
      async lazy() {
        const Comp = await import('./pages')
        return { Component: Comp.default }
      },
      exact: true,
    },
  ],
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}
